import { computed, ReadonlySignal, Signal, signal } from '@preact/signals'
import type AppStore from './AppStore'

export enum ScannerMode {
  OneDRetail = '1dRetail',
  QR = 'qr',
  OneDIndustrial = '1dIndustrial',
  DPM = 'dpm',
  TwoDAll = '2dAll',
  All = 'all',
  SwissQR = 'swissQR',
  Batch = 'batch',
  ExternalListBuilding = 'externalListBuilding',
  ExternalSearchAndFind = 'externalSearchAndFind',
}

export type TInitialOptionsStore = {
  scannerMode: Signal<ScannerMode | undefined>
  canStart: ReadonlySignal<boolean>
  launched: Signal<boolean>
  colorInvertedValue: Signal<boolean>
  colorInvertedEnabled: Signal<boolean>
  isConfigured: Signal<boolean>
  setScannerMode: (scannerModeType: ScannerMode) => void
  setColorInverted: (bool: boolean) => void
  setIsConfigured: (bool: boolean) => void
}

const InitialOptionsStore = (_: AppStore): TInitialOptionsStore => {
  const isConfigured = signal<boolean>(false)
  const scannerMode = signal<ScannerMode | undefined>(undefined)
  const canStart = computed(() => scannerMode.value !== undefined && isConfigured.value === true)
  const launched = signal(false)
  const colorInvertedValue = signal(false)
  const colorInvertedEnabled = computed(() => {
    if (
      scannerMode.value === ScannerMode.ExternalListBuilding ||
      scannerMode.value === ScannerMode.ExternalSearchAndFind
    ) {
      colorInvertedValue.value = false
      return false
    }
    return true
  })

  const setScannerMode = async (scannerModeType: ScannerMode) => {
    scannerMode.value = scannerModeType
  }

  const setColorInverted = async (bool: boolean) => {
    colorInvertedValue.value = bool
  }

  const setIsConfigured = (bool: boolean) => {
    isConfigured.value = true
  }

  return {
    scannerMode,
    canStart,
    launched,
    colorInvertedEnabled,
    colorInvertedValue,
    isConfigured,
    setScannerMode,
    setColorInverted,
    setIsConfigured,
  }
}

export default InitialOptionsStore
